import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

export function MultisportGuard() {
  const user = useAuthStore((s) => s.user);
  if (
    user?.role === "hr" ||
    user?.role === "accountant" ||
    user?.is_ceo ||
    user?.has_multisport_access
  ) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
}
